import * as React from 'react';
import { breadcrumbs } from '@inqool/uas-web-core/es/utils';
import { compose, lifecycle, withState } from 'recompose';

import ExportButton from '@components/exportButton/ExportButton';
import { getCurrentEmployee } from '@modules/hr-dayplans/_dayplansActions';
import OverviewForm from './OverviewForm';

const enhance = compose(
  breadcrumbs([{ label: 'Personalistika - můj přehled' }]),
  withState('employeeId', 'setEmployeeId', null),
  lifecycle<any, any>({
    async componentDidMount() {
      await getCurrentEmployee().then(
        employee => {
          this.props.setEmployeeId(employee.id);
        },
        e => console.debug(e)
      );
    }
  })
);

const View: React.SFC<any> = ({ employeeId }) => (
  <>
    <div style={{ margin: '0 15px' }}>
      <ExportButton
        location="workPlanEvidenceOverview"
        formName="form.module-events"
        urlPrefix="/metropolis"
        exportLabel="Export"
        useFileNameDialog={true}
        defaultData={null}
        disabled={false}
      />
    </div>
    <OverviewForm employeeId={employeeId} />
  </>
);

export const MyOverview = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/hr-overview/MyOverview.tsx